<template>
    <qesg-dash-card-wrapper class="py-0 h-100" :no-body="true">
        <b-row no-gutters :class="['px-3 py-3', headerClass]" align-v="center">
            <slot name="header">
                <b-col cols>
                    <slot name="title">
                        <h5 :class="['dash-card-title mr-2 mb-0', titleClass]">{{ title }}</h5>
                    </slot>
                </b-col>
                <b-col cols="auto">
                    <slot name="icon">
                        <div class="d-flex justify-content-end">
                            <qesg-dash-card-icon :icon="icon" :variant="iconVariant" :font-scale="iconFontScale" />
                        </div>
                    </slot>
                </b-col>
            </slot>
        </b-row>
        <b-card-body class="px-0 py-0">
            <slot />
        </b-card-body>
    </qesg-dash-card-wrapper>
</template>

<script>
import qesgDashCardPropsDefault from '@shared_mixins/contractor-dashboard/qesg-dash-card-props-default.js';
import qesgDashCardPropsIcon from '@shared_mixins/contractor-dashboard/qesg-dash-card-props-icon.js';
import QesgDashCardWrapper from '@shared_components/contractor/components/qesg-dash-card-wrapper.vue';
import QesgDashCardIcon from '@shared_components/contractor/components/qesg-dash-card-icon.vue';

export default {
    name: 'qesg-dash-table-card',
    components: {
        QesgDashCardWrapper,
        QesgDashCardIcon
    },
    mixins: [
        qesgDashCardPropsDefault,
        qesgDashCardPropsIcon
    ],
    props: {
        headerClass: {
            type: [ String, Array, Object ]
        }
    },
    computed: {
        dashCardNobody () {
            const noBodyProps = typeof this.noBody !== 'undefined' ? true : this.noBody
            return noBodyProps || this.isTable
        }
    }
}
</script>

<style>

</style>